
import { useRouteServer }
  from 'app/context/route-servers';
import { useNeighbors }
  from 'app/context/neighbors';
import { isUpState }
  from 'app/components/neighbors/state';

import Status
  from 'app/components/status/Status';

import Neighbors
  from 'app/components/neighbors/Neighbors';
import QuickLinks
  from 'app/components/neighbors/QuickLinks';

import PageHeader
  from 'app/components/page/Header';
import SearchQueryInput
  from 'app/components/search/SearchQueryInput';
import SummaryCards, { SummaryCard }
  from 'app/components/summary/SummaryCards';

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  detailsMain: {
    display: "flex",
    flexDirection: "row",
    gap: 16,
    [`@media (max-width:900px)`]: {
      flexDirection: "column",
    },
  },
  pageHeader: {
    borderBottom: "1px solid #e0e0e0",
  }
});


/** 
 * The NeighborsPage renders a list of all peers on
 * the route server.
 *
 * A search field for quick filtering is provided
 */
const NeighborsPage = () => {
  const classes = useStyles();
  const routeServer = useRouteServer();
  const { neighbors, isLoading } = useNeighbors();
  if (!routeServer) { return null; } // nothing to do here
  const established = neighbors.filter((neighbor) => isUpState(neighbor.state)).length;
  const unavailable = neighbors.length - established;
  const availability = neighbors.length
    ? `${Math.round((established / neighbors.length) * 100)}%`
    : "—";

  return (
    <div className="routeservers-page">
      <PageHeader
        title={routeServer.name}
        subtitle="BGP sessions e peers deste route server." />

      <SummaryCards ariaLabel="Resumo das BGP sessions">
        <SummaryCard label="Peers" value={isLoading ? "—" : neighbors.length} />
        <SummaryCard
          label="BGP Sessions Established"
          value={isLoading ? "—" : established}
          tone="success" />
        <SummaryCard
          label="Sessions indisponíveis"
          value={isLoading ? "—" : unavailable}
          tone={unavailable ? "danger" : "default"} />
        <SummaryCard
          label="Disponibilidade"
          value={isLoading ? "—" : availability}
          tone="success" />
      </SummaryCards>

      <div className={`row details-main ${classes.detailsMain}`}>
        <div className="col-main col-lg-9 col-md-12">
          <div className="card">
            <SearchQueryInput
              placeholder="Filtrar por Neighbor, ASN ou descrição" />
          </div>
          <QuickLinks />
          <Neighbors />
        </div>
        <div className="col-lg-3 col-md-12 col-aside-details">
          <div className="card">
            <Status />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NeighborsPage;
